export type EventNameType =
  | 'button_margin_simulation' // 証拠金・エクスポージャーのシミュレーションボタンをクリック
  | 'button_available_deal_simulation' // 取引可否シミュレーションボタンをクリック

export const EVENT_NAME = {
  BUTTON_MARGIN_SIMULATION: 'button_margin_simulation',
  BUTTON_AVAILABLE_DEAL_SIMULATION: 'button_available_deal_simulation',
} as const
